"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionEmployeeType;
(function (SubscriptionEmployeeType) {
    SubscriptionEmployeeType["PAID"] = "PAID";
    SubscriptionEmployeeType["FREE"] = "FREE";
    SubscriptionEmployeeType["TRAINEE"] = "TRAINEE";
})(SubscriptionEmployeeType = exports.SubscriptionEmployeeType || (exports.SubscriptionEmployeeType = {}));
//# sourceMappingURL=SubscriptionEmployeeType.js.map